import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ToastService } from '@libs/src/toast/toast.service';

import { GroupMatchViewComponent } from './group-match-view.component';

import { ProgressSpinnerModule } from '../../progress-spinner/progress-spinner.module';

@NgModule({
  imports: [CommonModule, ProgressSpinnerModule, RouterModule],
  declarations: [GroupMatchViewComponent],
  exports: [GroupMatchViewComponent],
  providers: [ToastService],
})
export class GroupMatchViewModule {}
